<template>
  <div
    class="absolute top-[100px] right-3 z-10 bg-white px-2 py-1.5 h-[575px] w-96 overflow-y-auto rounded-md"
  >
    <h5 class="font-semibold flex justify-center py-3">History Area</h5>

    <div class="px-3 pt-3">
      <SearchInput @input="search" id="history" />
    </div>

    <div class="pt-3 px-3" v-if="!features.loading">
      <div v-if="features.rows?.length != 0">
        <table class="w-full text-sm text-gray-500">
          <thead>
            <tr class="bg-white border text-center">
              <th scope="row" class="py-3 px-2">Kode Petak</th>
              <th scope="row" class="py-3 px-2">Feature ID</th>
              <th scope="row" class="py-3 px-2">Luas</th>
              <th scope="row" class="py-3 px-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="bg-white border"
              v-for="item in features.rows"
              :key="item.feature_id"
              :class="[
                { 'hover:bg-lightGray': selected != item.feature_id },
                { 'bg-gray100': selected == item.feature_id },
              ]"
            >
              <td class="py-3 px-2">{{ item.properties.kode_petak }}</td>
              <td class="py-3 px-2">{{ item.feature_id }}</td>
              <td class="py-3 px-2 text-right">
                {{
                  item.properties.luasha.toString().length < 5
                    ? item.properties.luasha
                    : item.properties.luasha.toFixed(4)
                }}
                HA
              </td>
              <td class="flex gap-2 items-center justify-center py-3 px-2">
                <div @click="toArea(item)" class="cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                  </svg>
                </div>

                <div
                  @click="showScene(item.properties.kode_petak)"
                  class="cursor-pointer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                  </svg>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <PaginationNoNumber
          v-model:length="length"
          v-model:size="limit"
          v-model:page="page"
          @onSelectChange="changePage"
        />
      </div>
    </div>

    <LoadingLoad class="py-5" v-if="features.loading" />

    <div
      class="text-sm font-bold text-gray-700 flex justify-center py-2"
      v-if="features.rows?.length == 0"
    >
      No Data
    </div>

    <AlertErrorComponent
      v-if="features.error"
      :message="features.error.response.data.message"
    />
  </div>
</template>

<script>
import AlertErrorComponent from "@/components/AlertErrorComponent.vue";
import LoadingLoad from "@/components/LoadingLoad.vue";
import PaginationNoNumber from "@/components/PaginationNoNumber.vue";
import SearchInput from "@/components/SearchInput.vue";
import router from "@/router";
import { useSceneStore } from "@/store";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { onMounted } from "vue";

export default {
  components: {
    PaginationNoNumber,
    SearchInput,
    LoadingLoad,
    AlertErrorComponent,
  },
  props: {
    selected: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const sceneStore = useSceneStore();
    const { features } = storeToRefs(sceneStore);

    const limit = ref(50);
    const offset = ref(0);
    const page = ref(1);
    const length = ref(0);
    const q = ref(null);

    const getFeatures = async () => {
      await sceneStore.getAllSgnksofeatures({
        offset: offset.value,
      });
      length.value = features.value.count;
    };

    onMounted(() => {
      getFeatures();
    });

    const toArea = async (val) => {
      emit("gotoarea", val.feature_id);
    };

    const changePage = async (value) => {
      page.value = value;
      offset.value = (page.value - 1) * limit.value;
      let dataparams = { offset: offset.value };

      if (q.value != null || q.value != "") {
        dataparams = {
          ...dataparams,
          q: q.value,
        };
      }
      await sceneStore.getAllSgnksofeatures(dataparams);
      length.value = features.value.count;
    };

    const search = async (value) => {
      offset.value = 0;
      page.value = 1;
      q.value = value.target.value;

      let dataparams = {
        offset: offset.value,
        q: value.target.value,
      };

      await sceneStore.getAllSgnksofeatures(dataparams);
      length.value = features.value.count;
    };

    const showScene = (feature_id) => {
      router.push(`/maps/${feature_id}`);
    };

    return {
      toArea,
      features,
      limit,
      page,
      length,
      changePage,
      search,
      showScene,
    };
  },
};
</script>
